import Icon from '../components/Icon.vue'

Icon.register({
  'object-group': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M480 128v288h20c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-20h-384v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h20v-320h-20c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h384v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-20v32zM96 276c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-136c0-6.6-5.4-12-12-12h-168c-6.6 0-12 5.4-12 12v136zM416 372v-136c0-6.6-5.4-12-12-12h-84v72c0 13.3-10.7 24-24 24h-72v52c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/object-group.js
// module id = 1597
// module chunks = 0